const selectors = {
  component: "[data-cp]",
  image: "[data-cp-image]",
  format: "[data-cp-format]",
};

const initComponent = (component) => {
  const formats = component.querySelectorAll(selectors.format);
  const images = component.querySelectorAll(selectors.image);

  formats?.forEach((format, activeIndex) =>
    format.addEventListener("click", () =>
      images.forEach((image, index) => image.setAttribute("data-cp-image", index === activeIndex ? "active" : ""))
    )
  );

  formats[0].click();
};

document.addEventListener(
  "DOMContentLoaded",
  async function () {
    const components = document.querySelectorAll(selectors.component);

    components?.forEach((component) => initComponent(component));
  },
  {
    once: true,
  }
);
